export const reportBrokenUrlsStyle = (theme) => ({
  contentAll: {
    [theme.breakpoints.up("sm")]: {
      height: "calc(100vh - 64px)",
    },
    overflow: "auto",
  },
  root: {
    width: '100%',
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    "& th": {
      borderBottom: "1px solid rgba(224, 224, 224, 1) !important",
      color:"#404040 !important"
    }
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  title: {
    flex: '1 1 100%',
  },
  approve: {
    color: "#515151",
    fontSize: "16px",
    letterSpacing: "0.13px",
    textAlign: "center",
    "&:hover": {
      color: "#515151",
      opacity: ".6",
    },
  },
});
